import * as React from "react"
import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"

import { AvailableButton } from "../../@components"
import { useAdminSkuTable } from "../../@hooks"


export default function availablesColumn() {
    return [{
        name: "availableToFilters", label: "Availabilities",
        options: { display: "excluded" }
    }, {
        name: "availables", label: "Availabilities",
        options: {
            sort: false,
            filter: false,
            customBodyRowRenderLite: (value, rowData) => <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                minWidth={150}
            >
                <ButtonAvailable
                    data={value}
                    rowData={rowData}
                    name="available_pricing"
                    label="Pricing"
                />

                <ButtonAvailable
                    data={value}
                    rowData={rowData}
                    name="available_marketplaces"
                    label="Marketplaces"
                />
            </Box>
        }
    }]
}

const ButtonAvailable = ({ data, rowData, name, label }) => {
    const status = data[name]
    const localStatus = useSignal(status)
    const { handleAvailable } = useAdminSkuTable(rowData.skuID, name)

    useEffect(() => {
        localStatus.value = status
    }, [status])

    return <AvailableButton
        status={localStatus.value}
        label={label}
        onClick={() => {
            const newValue = !localStatus.value
            localStatus.value = newValue
            handleAvailable(newValue)
        }}
    />
}